import { interpolate } from './interpolate';

/**
 * Lightens a given color by interpolating it towards white.
 *
 * @param color - The base color to lighten, as a string (e.g., hex or CSS color).
 * @param amount - The interpolation amount between 0 and 1, where 0 returns the original color and 1 returns white.
 * @returns The lightened color as a string.
 */
export const interpolateLighten = (color: string, amount: number): string => {
  return interpolate(color, '#ffffff', amount);
};
